import { Amplify } from 'aws-amplify';
import config from '../config';
import { getEnv } from '../config';
import { instance } from '../_shared/services/instance';
import { get } from 'lodash';
import { AppActions } from '../app.reducer';
import { initToastHelper } from '../_shared/lib/toast-helper';

// Not _log/_warn/_error: Jest's console implements log() by calling this._log(), so an
// override with that name recurses forever under test.
//@ts-ignore
console.devLog = (...args) => {
  const env = getEnv();
  if (env !== 'prod') {
    //@ts-ignore
    // tslint:disable-next-line
    console.log(...args);
  }
};

//@ts-ignore
console.devWarn = (...args) => {
  const env = getEnv();
  if (env !== 'prod') {
    console.warn(...args);
  }
};

//@ts-ignore
console.devError = (...args) => {
  const env = getEnv();
  if (env !== 'prod') {
    console.error(...args);
  }
};

export default () => {
  const conf = config();

  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: conf.aws_identity_pool,
        userPoolId: conf.aws_user_pool,
        userPoolClientId: conf.aws_webclient_id,
      },
    },
  });

  initToastHelper();

  require('./support');
};

export const loadIntegration = async (store: any, integrationid?: string) => {
  const [end, domain, sub, integration] = window.location.host
    .split(':')
    .join('.')
    .split('.')
    .reverse();

  const int = integrationid || integration || sub;
  if (int) {
    const result = await instance.get(`/content/integration/${int}`);

    const data = get(result, 'data.data', {});

    store.dispatch({ type: AppActions.SET_APP, payload: data });
  }
};
